/**
  * MISC CUSTOM SVG ICONS
  * When importing SVG asset files here
  * please prep the SVG file by removing
  * any styling form the <style> tag or inline
  * as it conflicts with our application CSS.
 */
export const ixSvgIcons = {
  anti_lock: 'assets/customicons/anti-lock.svg',
  two_factor_auth: 'assets/customicons/2fa.svg',
  dataset: 'assets/customicons/dataset.svg',
  ha_disabled: 'assets/customicons/ha_disabled.svg',
  ha_enabled: 'assets/customicons/ha_enabled.svg',
  ha_reconnecting: 'assets/customicons/ha_reconnecting.svg',
  hdd_mirror: 'assets/customicons/ix-hdd-mirror.svg',
  hdd: 'assets/customicons/ix-hdd.svg',
  cloud_sync: 'assets/customicons/ix-cloud-sync.svg',
  rsync: 'assets/customicons/ix-rsync.svg',
  replication: 'assets/customicons/ix-replication.svg',
  iscsi_share: 'assets/customicons/iscsi-share.svg',
  multipath: 'assets/customicons/multipath.svg',
  network_upload_download_disabled: 'assets/customicons/network-upload-download-disabled.svg',
  network_upload_download: 'assets/customicons/network-upload-download.svg',
  nfs_share: 'assets/customicons/nfs-share.svg',
  openzfs: 'assets/customicons/openzfs.svg',
  quota_fill: 'assets/customicons/quota-fill.svg',
  reservation_fill: 'assets/customicons/reservation-fill.svg',
  smb_share: 'assets/customicons/smb-share.svg',
  ssd_mirror: 'assets/customicons/ix-ssd-mirror.svg',
  ssd: 'assets/customicons/ix-ssd.svg',
  logo_truecommand_blue: 'assets/images/truecommand/truecommand-logo-mark-full-color-rgb.svg',
  logo_truecommand_white: 'assets/images/truecommand/truecommand-logo-mark-white-rgb.svg',
  logo_truenas_scale_full: 'assets/customicons/truenas_scale_logo_full.svg',
  logo_truenas_scale_mark_color: 'assets/customicons/truenas_scale_logomark_rgb.svg',
  logo_truenas_scale_mark: 'assets/customicons/truenas_scale_logomark.svg',
  logo_truenas_scale_type_color: 'assets/customicons/truenas_scale_logotype_rgb.svg',
  logo_truenas_scale_type: 'assets/customicons/truenas_scale_logotype.svg',
  logo_freenas_certified: 'assets/customicons/logo_certified.svg',
  logo_mark_rgb: 'assets/customicons/ix_logomark_rgb.svg',
  logo_mark: 'assets/customicons/ix_logomark.svg',
  logo_full_rgb: 'assets/customicons/ix_full_logo_rgb.svg',
  logo_full: 'assets/customicons/ix_full_logo.svg',
  enclosure: 'assets/customicons/enclosure.svg',
};
